/* =============================================================
   HP Search Overlay - Logic
   - Aggancia la search bar dell'header (intercetta focus/click)
   - Shopify Predictive Search API
   - Debounce, focus trap, ESC, click-outside, recent searches
   - Add-to-cart inline
   ============================================================= */
(function () {
  'use strict';

  if (window.__hpSearchOverlayInit) return;
  window.__hpSearchOverlayInit = true;

  // -------- Config (caricata da <script type="application/json" data-hp-so-config>)
  function loadConfig() {
    var el = document.querySelector('[data-hp-so-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var CFG = loadConfig() || {};
  CFG.routes = CFG.routes || {};
  CFG.selectors = CFG.selectors || 'input[type="search"]';
  CFG.limit = CFG.limit || 6;
  CFG.debounce_ms = CFG.debounce_ms || 250;
  CFG.labels = CFG.labels || {};

  // -------- Overlay DOM
  var overlay     = document.getElementById('hpSearchOverlay');
  if (!overlay) return;
  var modal       = overlay.querySelector('[data-hp-so-modal]');
  var input       = overlay.querySelector('[data-hp-so-input]');
  var closeBtn    = overlay.querySelector('[data-hp-so-close]');
  var backdrop    = overlay.querySelector('[data-hp-so-backdrop]');
  var resultsEl   = overlay.querySelector('[data-hp-so-results]');
  var idleEl      = overlay.querySelector('[data-hp-so-state="idle"]');
  var loadingEl   = overlay.querySelector('[data-hp-so-state="loading"]');
  var emptyEl     = overlay.querySelector('[data-hp-so-state="empty"]');
  var emptyQuery  = overlay.querySelector('[data-hp-so-empty-query]');
  var seeAllEl    = overlay.querySelector('[data-hp-so-see-all]');
  var recentBlock = overlay.querySelector('[data-hp-so-recent]');
  var recentList  = overlay.querySelector('[data-hp-so-recent-list]');
  var clearRecent = overlay.querySelector('[data-hp-so-clear-recent]');
  var recentToggle = overlay.querySelector('[data-hp-so-recent-toggle]');
  var recentPanel  = overlay.querySelector('[data-hp-so-recent-panel]');
  var recentCount  = overlay.querySelector('[data-hp-so-recent-count]');

  var STORAGE_KEY = 'hp_so_recent_v1';
  var MAX_RECENT  = 6;

  // ============ UTILS ============
  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    /* Shopify Predictive Search JSON API ritorna i prezzi come decimale ("25.50"),
       NON come centesimi. Quindi nessuna divisione per 100. */
    return '€' + n.toFixed(2).replace('.', ',');
  }

  function escapeHTML(s) {
    return String(s || '').replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function setState(state) {
    [idleEl, loadingEl, emptyEl, resultsEl].forEach(function (n) {
      if (n) n.hidden = (n.getAttribute('data-hp-so-state') !== state);
    });
    if (seeAllEl) seeAllEl.hidden = (state !== 'results');
  }

  // ============ RECENT SEARCHES ============
  function getRecent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }
  function setRecent(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX_RECENT))); }
    catch (e) {}
  }
  function pushRecent(term) {
    if (!CFG.enable_recent) return;
    term = (term || '').trim();
    if (term.length < 2) return;
    var arr = getRecent().filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
    arr.unshift(term);
    setRecent(arr);
    renderRecent();
  }
  function renderRecent() {
    if (!CFG.enable_recent || !recentBlock || !recentList) return;
    var arr = getRecent();
    if (!arr.length) {
      recentBlock.hidden = true;
      return;
    }
    recentBlock.hidden = false;
    /* Aggiorna il count nel pulsante toggle */
    if (recentCount) recentCount.textContent = arr.length;
    /* Popola la lista dentro il panel (che e' collapsed di default) */
    recentList.innerHTML = arr.map(function (term) {
      var safe = escapeHTML(term);
      var url = CFG.routes.search + '?q=' + encodeURIComponent(term);
      return '' +
        '<li>' +
          '<a href="' + url + '" class="hp-so__list-link" data-hp-so-suggest="' + safe + '">' +
            '<span class="hp-so__list-icon" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>' +
              '</svg>' +
            '</span>' +
            '<span class="hp-so__list-label">' + safe + '</span>' +
          '</a>' +
        '</li>';
    }).join('');
  }

  /* Toggle apri/chiudi panel ricerche recenti */
  if (recentToggle && recentPanel) {
    recentToggle.addEventListener('click', function () {
      var expanded = recentToggle.getAttribute('aria-expanded') === 'true';
      var next = !expanded;
      recentToggle.setAttribute('aria-expanded', next ? 'true' : 'false');
      recentPanel.hidden = !next;
      var labelEl = recentToggle.querySelector('.hp-so__recent-toggle-label');
      if (labelEl) labelEl.textContent = next ? 'Nascondi ricerche recenti' : 'Mostra ricerche recenti';
    });
  }
  if (clearRecent) {
    clearRecent.addEventListener('click', function () {
      setRecent([]);
      renderRecent();
      /* Chiudi il panel se non ci sono piu' ricerche */
      if (recentToggle && recentPanel) {
        recentToggle.setAttribute('aria-expanded', 'false');
        recentPanel.hidden = true;
        var labelEl = recentToggle.querySelector('.hp-so__recent-toggle-label');
        if (labelEl) labelEl.textContent = 'Mostra ricerche recenti';
      }
    });
  }

  // ============ OPEN / CLOSE ============
  var lastFocus = null;
  var scrollbarW = window.innerWidth - document.documentElement.clientWidth;

  var savedScrollY = 0;

  /* Calcola la Y in viewport del modal (sopra la search bar) e la Y del
     backdrop (sotto l'announcement bar), cosi':
       - Modal si "incolla" alla search bar dell'header
       - Backdrop scuro copre TUTTO sotto l'announcement bar (incluso il logo) */
  function computeAnchorY(triggerEl) {
    var anchorY = 80;
    var anchorW = 1100;
    var bdTop = 0;
    if (triggerEl) {
      try {
        /* Cerco il "form container" della search bar (piu' largo del solo input),
           cosi' la width matcha il box visibile, non solo il campo. */
        var box = triggerEl.closest('form, .search-form, .header__search, .header-search-inner') || triggerEl;
        var rect = box.getBoundingClientRect();
        anchorY = Math.max(0, Math.round(rect.top));
        /* Aggiungiamo respiro laterale (+80px) per non essere strettissimo */
        anchorW = Math.min(1280, Math.round(rect.width) + 80);
      } catch (e) {}
    }
    /* Calcolo la Y di fine dell'announcement bar (se presente) */
    try {
      var ann = document.querySelector('#shopify-section-announcement-bar, .shopify-section-group-announcement-group, [class*="announcement-bar"]');
      if (ann) {
        var ar = ann.getBoundingClientRect();
        bdTop = Math.max(0, Math.round(ar.bottom));
      }
    } catch (e) {}
    document.documentElement.style.setProperty('--hp-so-anchor-y', anchorY + 'px');
    document.documentElement.style.setProperty('--hp-so-anchor-w', anchorW + 'px');
    document.documentElement.style.setProperty('--hp-so-bd-top', bdTop + 'px');
  }

  function hpPreventScroll(e) {
    /* blocca lo scroll della PAGINA; consenti solo lo scroll DENTRO il box modale.
       Il backdrop e' fuori dal modal -> scrollando li' (mouse fuori dal box) resta bloccato. */
    if (!modal || !modal.contains(e.target)) e.preventDefault();
  }

  function openOverlay(prefill, triggerEl) {
    if (overlay.getAttribute('aria-hidden') === 'false') return;
    lastFocus = document.activeElement;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    computeAnchorY(triggerEl);
    overlay.hidden = false;
    document.body.style.setProperty('--hp-so-scrollbar-w', scrollbarW + 'px');
    document.documentElement.classList.add('hp-so-open');
    document.body.classList.add('hp-so-open');
    /* Scroll lock via eventi: NON tocca overflow/position, quindi lo sticky
       dell'header resta intatto e la pagina non salta ne' si sposta. */
    window.addEventListener('wheel', hpPreventScroll, { passive: false });
    window.addEventListener('touchmove', hpPreventScroll, { passive: false });
    // Chiudi l'overlay di ricerca NATIVO del tema (su mobile la lente lo apriva
    // sotto la nostra ricerca → doppia ricerca + "X verde" residua). Lo chiudiamo
    // a livello logico (Alpine) appena apriamo la nostra.
    try {
      document.querySelectorAll('[id^="FormSearch__"]').forEach(function (f) {
        f.classList.remove('is-open');
        if (f.__x && f.__x.$data) {
          try { f.__x.$data.isFocusedSearchForm = false; } catch (e) {}
          if (typeof f.__x.$data.close === 'function') { try { f.__x.$data.close(); } catch (e) {} }
        }
      });
    } catch (e) {}
    // forziamo reflow per attivare la transizione
    void overlay.offsetWidth;
    overlay.setAttribute('aria-hidden', 'false');
    renderRecent();
    setTimeout(function () {
      if (typeof prefill === 'string' && prefill.trim()) {
        input.value = prefill.trim();
        onInput();
      } else {
        setState('idle');
      }
      input.focus({ preventScroll: true });
      input.select && input.select();
    }, 30);
  }

  function closeOverlay() {
    if (overlay.getAttribute('aria-hidden') !== 'false') return;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hp-so-open');
    document.body.classList.remove('hp-so-open');
    window.removeEventListener('wheel', hpPreventScroll, { passive: false });
    window.removeEventListener('touchmove', hpPreventScroll, { passive: false });
    setTimeout(function () {
      overlay.hidden = true;
      input.value = '';
      setState('idle');
      /* Reset toggle ricerche recenti a chiuso */
      if (recentToggle && recentPanel) {
        recentToggle.setAttribute('aria-expanded', 'false');
        recentPanel.hidden = true;
        var labelEl = recentToggle.querySelector('.hp-so__recent-toggle-label');
        if (labelEl) labelEl.textContent = 'Mostra ricerche recenti';
      }
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
      }
    }, 220);
  }

  backdrop.addEventListener('click', closeOverlay);
  closeBtn.addEventListener('click', closeOverlay);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
      e.preventDefault();
      closeOverlay();
    }
  });

  // Focus trap minimo (Tab cyclca dentro modal)
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusable = modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });

  // ============ TRIGGER AGGANCIO SEARCH BAR ESISTENTE ============
  function bindTriggers() {
    var nodes = document.querySelectorAll(CFG.selectors);
    nodes.forEach(function (el) {
      if (el === input) return; // mai sull'input dell'overlay stesso
      // Campi di ricerca "locali" (es. "Cerca un marchio" nella pagina dei brand): filtrano
      // l'elenco della loro pagina e non devono aprire la ricerca prodotti.
      if (el.hasAttribute('data-brand-search') || el.closest('[data-hp-so-ignore]')) return;
      if (el.dataset.hpSoBound) return;
      el.dataset.hpSoBound = '1';
      // Apriamo su focus, click, keydown
      var open = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prefill = el.value || '';
        el.blur();
        openOverlay(prefill, el);
      };
      el.addEventListener('focus', open);
      el.addEventListener('mousedown', open);
      el.addEventListener('touchstart', open, { passive: false });
    });
  }
  bindTriggers();
  // Re-bind dopo eventuali render dinamici (es. theme editor)
  var moObs = new MutationObserver(debounce(bindTriggers, 150));
  moObs.observe(document.body, { childList: true, subtree: true });

  // ============ INPUT + SEARCH ============
  function showClear() { /* rimosso: il clear button non esiste piu' */ }

  var lastQuery = '';
  var currentReq = null;

  function fetchPredictive(q) {
    if (currentReq && currentReq.abort) currentReq.abort();
    var base = (CFG.routes.suggest || '/search/suggest.json');
    // Sicurezza: se per qualche motivo arriva /search/suggest senza .json, lo aggiustiamo
    if (base.indexOf('.json') === -1) {
      base = base.replace(/\/$/, '') + '.json';
    }
    var url = base +
              '?q=' + encodeURIComponent(q) +
              '&resources[type]=product' +
              '&resources[limit]=' + CFG.limit +
              '&resources[options][unavailable_products]=last' +
              '&resources[options][fields]=title,product_type,variants.title,vendor';

    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    currentReq = ctrl;
    var opts = ctrl ? { signal: ctrl.signal } : {};
    opts.headers = { 'Accept': 'application/json' };
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('Predictive search HTTP ' + r.status);
      return r.json();
    });
  }

  function renderResults(products, query) {
    if (!products.length) {
      if (emptyQuery) emptyQuery.textContent = '"' + query + '"';
      setState('empty');
      return;
    }
    resultsEl.innerHTML = products.map(function (p) {
      var img = (p.featured_image && p.featured_image.url)
        ? p.featured_image.url
        : (p.image || '');
      var imgSrc = img ? (img.indexOf('//') === 0 ? 'https:' + img : img) : '';

      var price = formatMoney(p.price);
      var compare = (p.compare_at_price_min && p.compare_at_price_min > p.price_min)
        ? p.compare_at_price_min
        : ((p.compare_at_price && p.compare_at_price > p.price) ? p.compare_at_price : 0);
      var compareHtml = compare
        ? '<span class="hp-so__item-compare">' + formatMoney(compare) + '</span>'
        : '';

      // rating "fake visuale" stelle (5 piene)
      var stars = '';
      for (var i = 0; i < 5; i++) {
        stars += '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3.1 6.3L22 9.3l-5 4.9L18.2 22 12 18.6 5.8 22 7 14.2 2 9.3l6.9-1z"/></svg>';
      }

      var firstVariantId = (p.variants && p.variants[0] && p.variants[0].id) ? p.variants[0].id : null;
      var ctaHtml = (CFG.enable_addtocart && firstVariantId)
        ? '<button type="button" class="hp-so__item-cta" data-hp-so-add="' + firstVariantId + '" aria-label="Aggiungi al carrello">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6h15l-1.5 9h-12L6 6z"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M6 6L4 2H2"/></svg>' +
          '</button>'
        : '';

      var url = p.url || (CFG.routes.root + 'products/' + p.handle);

      return '' +
        '<li>' +
          '<a class="hp-so__item" href="' + url + '" data-hp-so-result>' +
            '<span class="hp-so__item-img">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHTML(p.title) + '" loading="lazy" width="64" height="64">' : '') +
            '</span>' +
            '<span class="hp-so__item-body">' +
              '<span class="hp-so__item-title">' + escapeHTML(p.title) + '</span>' +
              '<span class="hp-so__item-meta">' +
                '<span class="hp-so__item-rating" aria-hidden="true">' + stars + '</span>' +
              '</span>' +
              '<span class="hp-so__item-prices">' +
                '<span class="hp-so__item-price">' + price + '</span>' +
                compareHtml +
              '</span>' +
            '</span>' +
            ctaHtml +
          '</a>' +
        '</li>';
    }).join('');
    setState('results');
    /* href + label gestiti da updateSeeAllText() chiamato in onInput */
  }

  function fetchTotalCount(q) {
    /* Chiama il template alternativo /search?view=count che ritorna {"count":N}
       (vedi templates/search.count.liquid del tema) */
    var url = '/search?q=' + encodeURIComponent(q) + '&type=product&view=count';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function updateSeeAllText(count, query) {
    if (!seeAllEl) return;
    seeAllEl.href = CFG.routes.search + '?q=' + encodeURIComponent(query);
    var label = (typeof count === 'number' && count > 0)
      ? 'Vedi tutti i ' + count + ' prodotti'
      : 'Vedi tutti i risultati';
    var span = seeAllEl.querySelector('.hp-so__see-all-label');
    if (span) {
      span.textContent = label;
    } else {
      /* Ristruttura: testo + freccia */
      seeAllEl.innerHTML = '<span class="hp-so__see-all-label">' + label + '</span>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
    }
  }

  function onInput() {
    var q = input.value.trim();
    showClear();
    if (q.length < 2) {
      setState('idle');
      return;
    }
    setState('loading');
    lastQuery = q;
    fetchPredictive(q)
      .then(function (data) {
        if (q !== lastQuery) return; // out-of-order safety
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        try { console.log('[HP Search]', q, 'risultati:', products.length, data); } catch (e) {}
        renderResults(products, q);
        /* Mostra subito il count dei visibili come fallback, poi chiedi il count totale */
        updateSeeAllText(products.length, q);
        fetchTotalCount(q).then(function (countData) {
          if (q !== lastQuery) return;
          if (countData && typeof countData.count === 'number') {
            updateSeeAllText(countData.count, q);
          }
        });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        try { console.error('[HP Search] errore fetch:', err); } catch (e) {}
        setState('empty');
        if (emptyQuery) emptyQuery.textContent = '"' + q + '"';
      });
  }

  var onInputDebounced = debounce(onInput, CFG.debounce_ms);
  input.addEventListener('input', onInputDebounced);

  // Invio = vai alla pagina search
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var q = input.value.trim();
      if (q) {
        pushRecent(q);
        window.location.href = CFG.routes.search + '?q=' + encodeURIComponent(q);
      }
    }
  });

  // Click su un suggerimento sidebar (popolari/categorie/marchi/recenti)
  overlay.addEventListener('click', function (e) {
    var suggest = e.target.closest('[data-hp-so-suggest]');
    if (suggest) {
      var term = suggest.getAttribute('data-hp-so-suggest');
      pushRecent(term);
      // l'href naviga normalmente
      return;
    }

    var result = e.target.closest('[data-hp-so-result]');
    if (result) {
      pushRecent(input.value);
      return;
    }

    var addBtn = e.target.closest('[data-hp-so-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(addBtn);
    }
  });

  // ============ ADD TO CART INLINE ============
  function addToCart(btn) {
    var id = btn.getAttribute('data-hp-so-add');
    if (!id) return;
    btn.disabled = true;
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');

    fetch((CFG.routes.cart_add || '/cart/add.js'), {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: fd,
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.add('hp-so__item-cta--added');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg>';
        // refresh carrello del tema (drawer + bubble)
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var bubble = document.querySelector('.cart-bubble__container, [data-cart-bubble]');
          if (bubble) {
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              var counters = document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble__count');
              counters.forEach(function (c) { c.textContent = cart.item_count; });
            });
          }
        } catch (e) {}
        setTimeout(function () { btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.disabled = false;
      });
  }

  // ============ INIT ============
  renderRecent();
  setState('idle');
})();
